
import { Vue, Component } from 'vue-property-decorator';
import { getRules } from '../api';
@Component
export default class Rule extends Vue {
  activeIndex = 1;
  tabs = [
    { text: '活动背景', id: 1 },
    { text: '组织形式', id: 2 },
    { text: '专题设置', id: 3 },
    { text: '参加条件', id: 4 },
    { text: '报名咨询', id: 5 },
  ];
  get rules() {
    return getRules(this.activeIndex);
  }
  changeTab(item: any) {
    this.activeIndex = item.id;
  }
}
